import React from "react"

const NoBookingResults = (props) => (
  <div className="stylish-table__row stylish-table__row--body">
    <div className="stylish-table__cell">
      <div>
        <span style={{ display: "block ruby" }}>
          <strong>{props.bookingNoSearchResultsText}</strong>
        </span>
      </div>
    </div>
  </div>
)

export default NoBookingResults
